import { Injectable } from '@angular/core';
import { Directionality, Direction } from '@angular/cdk/bidi';

/**
 * `index.html` hardcodes `dir="rtl"` on `<html>` for flicker-free RTL-by-default
 * boot, and `LanguageService` only flips `document.documentElement.dir` after an
 * async effect runs post-bootstrap. CDK's stock `Directionality` snapshots
 * `document.dir` once, at construction (lazily, whenever it's first injected —
 * e.g. by the first dialog/menu/overlay anywhere in the app), and never re-reads
 * it. Every overlay opened afterwards (dialogs included) reads `.value` once at
 * creation time, so a stale RTL snapshot leaks into every future dialog, even in
 * English. Read the document's dir live on every access instead of caching it.
 */
@Injectable({ providedIn: 'root' })
export class AppDirectionality extends Directionality {
  override get value(): Direction {
    return document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr';
  }
}
